export default __webpack_public_path__ + "static/media/apolino-bg-mobile.ea960f65.jpg";